"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = {
  ESP_TYPES: (0, _keyMirror.default)({
    NONE: null,
    MAILCHIMP_OAUTH: null,
    CAMPAIGN_MONITOR: null,
    AWEBER: null,
    CONSTANT_CONTACT: null,
    GET_RESPONSE: null
  }),
  ESP_CONNECTION_STATUS: (0, _keyMirror.default)({
    UNKNOWN: null,
    NOT_CONNECTED: null,
    CONNECTED: null,
    BROKEN: null
  }),
  ESP_MISCONFIGURED_REASON: (0, _keyMirror.default)({
    NO_CREDENTIALS: null,
    INVALID_CREDENTIALS: null
  }),
  ESP_NAME: {
    NONE: 'none',
    MAILCHIMP_OAUTH: 'MailChimp',
    CAMPAIGN_MONITOR: 'CampaignMonitor',
    AWEBER: 'AWeber',
    CONSTANT_CONTACT: 'Constant Contact',
    GET_RESPONSE: 'GetResponse'
  }
};
exports.default = _default;
module.exports = exports.default;